import { useDispatch, useSelector } from "react-redux";
import LoadPdfRendering from "./load-pdf";
import { useState, useRef } from "react";
import * as admin from "@/views/admin-dashboard/admin.slice";
import { reportAutoFillResponseToAnnuncement } from "@/common/announcement-helper";

const FIRST_ITEM = 0;
const SECOND_ITEM = 1;

function LoadTechnicalPdf() {
  const dispatch = useDispatch();
  const status = useSelector(admin.selectStatus);
  const [dragActive, setDragActive] = useState(false);
  const [loadedAnnouncement, setLoadedAnnouncement] = useState();

  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);

    const files = event.dataTransfer.files;
    if (files?.length) {
      uploadFile({ file: files[FIRST_ITEM], dispatch, setLoadedAnnouncement });
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    const files = event.target.files;
    if (files?.length) {
      uploadFile({ file: files[FIRST_ITEM], dispatch, setLoadedAnnouncement });
    }
  };

  const handleButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <LoadPdfRendering
      onDrag={handleDrag}
      handleDrop={handleDrop}
      onChange={handleChange}
      onButtonClick={handleButtonClick}
      loadedAnnouncement={loadedAnnouncement}
      dragActive={dragActive}
      inputRef={inputRef}
      status={status}
    />
  );
}

function uploadFile({ file, dispatch, setLoadedAnnouncement }) {
  dispatch(admin.setStatus({ status: admin.Status.UPDATING }));
  getBase64(file, function (base64) {
    dispatch(
      admin.uploadFile({
        file: base64,
        fileName: file.name,
        type: file.type,
        size: Math.round(file.size / 1000) + " kB",
      })
    ).then((response_) => {
      const { response, fileName, file, type, size } = response_.payload;
      const announcement = reportAutoFillResponseToAnnuncement({
        response,
        fileName,
        file,
        type,
        size,
      });
      console.log(announcement);
      setLoadedAnnouncement(announcement);
    });
  });
}

function getBase64(file, callback) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    const val = reader.result.split("base64,")[SECOND_ITEM];
    callback(val);
  };
  reader.onerror = function (error) {
    console.log("Error: ", error);
  };
}

export default LoadTechnicalPdf;
